import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  status: 'to-active' | 'to-not-active';
  height: string;
  color: string;
}

const StepDivider: React.FC<Props> = ({ status, height, color }) => {
  const { classes, cx } = useStyles({ height, color });

  return <div className={cx(classes.stepDivider, status)} />;
};

const useStyles = makeStyles<{ height: string; color: string }>()((_theme, { height, color }) => ({
  stepDivider: {
    height,
    color,
    margin: '4px 0',
    marginLeft: 'calc((36px / 2) - 4px)',
    borderLeft: `2px dashed ${color}`,
    '&.to-active': {},
    '&.to-not-active': {
      height: `calc(${height} / 4)`,
      marginBottom: `calc(${height} - (${height} / 4) + 4px)`,
      opacity: 0.5,
    },
  },
}));

export default StepDivider;
